import {ClsConfig} from '../../../util/cls-config';
import {INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {EnumMCExpInsumos, EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import {ClsUtil} from '../../../util/cls-util';
import {EnumMasOpciones} from "../../../core/models/enum/enum-mas-opciones";
import {ClsManoDeObra, ClsManoDeObraMoneda} from 'src/app/core/models/cls-mano-de-obra';
import {inject} from "@angular/core";
import {ClsCatalogoCalculo, ClsCatalogoMOCalculo} from "../../../core/models/cls-calculo";
import {ClsObjGenerico} from "../../util/cls-obj-generico";
import {ClsParametro} from "../../../core/models/cls-parametros";
import {EnumParaPpto} from "../../../core/models/enum/enum-parametros";
import {EnumTipoParametro} from "../../../core/models/enum/enum-tipo-parametro";
import { ClsCatalogosExpIns } from 'src/app/core/models/cls-catalogo-general';

export class ClsObjManoDeObra extends ClsConfig {
  public gridMO: IgxGridComponent;
  // menu contextual
  private menus: INeodataMenu[] = [];
  // filtrado
  public dataMO: ClsManoDeObraMoneda[];
  public gridDataCompleta: ClsManoDeObraMoneda[] = [];
  private gridDataFiltrada: ClsManoDeObraMoneda[] = [];
  // obj
  public mObjGenerico: ClsObjGenerico;

  private infPpto = inject(AppPresupuestosService);
  constructor() {
    super();
  }

  public async getData(): Promise<ClsManoDeObra[]> {

    let params: ClsParametro[] = [];
    const expManoObra = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns.filter(x => x.Tipo === 2 && x.Nivel === 0 && !x.EsPorcentaje) || [];
    if (expManoObra.length > 0) {
      params = await this.mObjGenerico.obtenerNParametros(ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto,  EnumTipoParametro.Presupuesto, [{Parametro: EnumParaPpto.FRIESGOTRABAJO}, {Parametro: EnumParaPpto.FRIESGOTRABAJO2}]);
    }
    return this.procesarDatas(expManoObra, params);
  }

private procesarDatas(expManoObra: ClsCatalogosExpIns[], params: ClsParametro[]) {
  const dataManoObra: ClsManoDeObra[] = [];
  expManoObra.forEach(catGral => {
    const mo: ClsManoDeObra = this.inicializarRegistroAmbasMonedas();
    const costoMO: ClsCatalogoMOCalculo = this.buscarIdCatalogoCostoMO(catGral.IdCatalogo);
    mo.IdCatalogo = catGral.IdCatalogo;
    mo.Codigo = catGral.Codigo;
    mo.DescripcionLarga = catGral.DescripcionLarga;
    mo.Descripcion = catGral.Descripcion;
    mo.Unidad = catGral.Unidad;
    mo.Tipo = catGral.Tipo;
    if (!ClsUtil.esNulo(costoMO)) {
      mo.SalarioBaseMoneda1 = costoMO.SalarioBaseMoneda1 === 0 ? catGral.CostoMoneda1 : costoMO.SalarioBaseMoneda1;
      mo.SalarioBaseMoneda2 = costoMO.SalarioBaseMoneda2 === 0 ? catGral.CostoMoneda2 : costoMO.SalarioBaseMoneda2;
      mo.SalarioBaseMoneda3 = costoMO.SalarioBaseMoneda3;
      mo.FactorSalarioIntegradoMoneda1 = costoMO.FactorSalarioIntegradoMoneda1;
      mo.FactorSalarioIntegradoMoneda2 = costoMO.FactorSalarioIntegradoMoneda2;
      mo.FactorSalarioIntegradoMoneda3 = costoMO.FactorSalarioIntegradoMoneda3;
      mo.FasarMoneda1 = costoMO.FasarMoneda1;
      mo.FasarMoneda2 = costoMO.FasarMoneda2;
      mo.FasarMoneda3 = costoMO.FasarMoneda3;
      mo.SalarioIntegradoMoneda1 = costoMO.SalarioIntegradoMoneda1 === 0 ? catGral.CostoMoneda1 : costoMO.SalarioIntegradoMoneda1;
      mo.SalarioIntegradoMoneda2 = costoMO.SalarioIntegradoMoneda2 === 0 ? catGral.CostoMoneda2 : costoMO.SalarioIntegradoMoneda2;
      mo.SalarioIntegradoMoneda3 = costoMO.SalarioIntegradoMoneda3;
      mo.SalarioRealMoneda1 = costoMO.SalarioRealMoneda1 === 0 ? catGral.CostoMoneda1 : costoMO.SalarioRealMoneda1;
      mo.SalarioRealMoneda2 = costoMO.SalarioRealMoneda2 === 0 ? catGral.CostoMoneda2 : costoMO.SalarioRealMoneda2;
      mo.SalarioRealMoneda3 = costoMO.SalarioRealMoneda3;
      mo.ViaticosMoneda1 = costoMO.ViaticosMoneda1;
      mo.ViaticosMoneda2 = costoMO.ViaticosMoneda2;
      mo.ViaticosMoneda3 = costoMO.ViaticosMoneda3;
      mo.AlimentacionYHospedajeMoneda1 = costoMO.AlimentacionYHospedajeMoneda1;
      mo.AlimentacionYHospedajeMoneda2 = costoMO.AlimentacionYHospedajeMoneda2;
      mo.AlimentacionYHospedajeMoneda3 = costoMO.AlimentacionYHospedajeMoneda3;
      mo.GastosDeSepelioMoneda1 = costoMO.GastosDeSepelioMoneda1;
      mo.GastosDeSepelioMoneda2 = costoMO.GastosDeSepelioMoneda2;
      mo.GastosDeSepelioMoneda3 = costoMO.GastosDeSepelioMoneda3;
      mo.OtrasPrestacionesMoneda1 = costoMO.OtrasPrestacionesMoneda1;
      mo.OtrasPrestacionesMoneda2 = costoMO.OtrasPrestacionesMoneda2;
      mo.OtrasPrestacionesMoneda3 = costoMO.OtrasPrestacionesMoneda3;
      mo.TipoFasarMoneda1 = costoMO.TipoFasarMoneda1;
      mo.TipoFasarMoneda2 = costoMO.TipoFasarMoneda2;
      mo.TipoFasarMoneda3 = costoMO.TipoFasarMoneda3;
      const rtm1: number = costoMO.RiesgosdeTrabajoMoneda1;
      const rtm2: number = costoMO.RiesgosdeTrabajoMoneda2;
      const rtm3: number = costoMO.RiesgosdeTrabajoMoneda3;
      mo.RiesgosDeTrabajoMoneda1 = ClsUtil.esNulo(rtm1) || rtm1 === 0 ? ClsUtil.numberX(params[0].Valor) : rtm1;
      mo.RiesgosDeTrabajoMoneda2 = ClsUtil.esNulo(rtm2) || rtm2 === 0 ? ClsUtil.numberX(params[0].Valor) : rtm2;
      mo.RiesgosDeTrabajoMoneda3 = ClsUtil.esNulo(rtm3) || rtm3 === 0 ? ClsUtil.numberX(params[0].Valor) : rtm3;
    } else {
      mo.SalarioBaseMoneda1 = catGral.CostoMoneda1;
      mo.SalarioBaseMoneda2 = catGral.CostoMoneda2;
      mo.SalarioBaseMoneda3 = 0;
      mo.SalarioIntegradoMoneda1 = catGral.CostoMoneda1;
      mo.SalarioIntegradoMoneda2 = catGral.CostoMoneda2;
      mo.SalarioIntegradoMoneda3 = 0;
      mo.SalarioRealMoneda1 = catGral.CostoMoneda1;
      mo.SalarioRealMoneda2 = catGral.CostoMoneda2;
      mo.SalarioRealMoneda3 = 0;
    }
    mo.CostoTotalMoneda1 = catGral.CostoMoneda1;
    mo.CostoTotalMoneda2 = catGral.CostoMoneda2;
    mo.FechaMoneda1 = catGral.FechaMoneda1;
    mo.FechaMoneda2 = catGral.FechaMoneda2;
    mo.Participa = catGral.Participa;
    mo.EsPorcentaje = catGral.EsPorcentaje;
    dataManoObra.push(mo);
  });
  return dataManoObra;
}

  public getDataReporteManoObra(): ClsManoDeObra[] {
    const expMo = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns.filter(x => x.Tipo === 2 && x.Participa === true);
    return this.procesarDatas(expMo, [{Parametro: EnumParaPpto.FRIESGOTRABAJO, Valor: '0'}, {Parametro: EnumParaPpto.FRIESGOTRABAJO2, Valor: '0'}]);
  }

  public async crearObjMOEnBaseMonedaSeleccionada(menoda: boolean): Promise<ClsManoDeObraMoneda[]> {
    const data: ClsManoDeObra[] = await this.getData();

    return data.map(value => {
      const mo: ClsManoDeObraMoneda = new ClsManoDeObraMoneda();
      // Copia propiedades comunes
      mo.IdCatalogo = value.IdCatalogo;
      mo.Codigo = value.Codigo;
      mo.DescripcionLarga = value.DescripcionLarga;
      mo.Descripcion = value.Descripcion;
      mo.Unidad = value.Unidad;
      mo.Tipo = value.Tipo;
      mo.Participa = value.Participa;
      mo.EsPorcentaje = value.EsPorcentaje;
      // Asigna propiedades en base la moneda usando el objeto de mapeo
      mo.SalarioBase = menoda ? value.SalarioBaseMoneda1 : value.SalarioBaseMoneda2;
      mo.FactorSalarioIntegrado = menoda ? value.FactorSalarioIntegradoMoneda1 : value.FactorSalarioIntegradoMoneda2;
      mo.Fasar = menoda ? value.FasarMoneda1 : value.FasarMoneda2;
      mo.SalarioIntegrado = menoda ? value.SalarioIntegradoMoneda1 : value.SalarioIntegradoMoneda2;
      mo.SalarioReal = menoda ? value.SalarioRealMoneda1 : value.SalarioRealMoneda2;
      mo.Viaticos = menoda ? value.ViaticosMoneda1 : value.ViaticosMoneda2;
      mo.AlimentacionHospedaje = menoda ? value.AlimentacionYHospedajeMoneda1 : value.AlimentacionYHospedajeMoneda2;
      mo.GastosSepelio = menoda ? value.GastosDeSepelioMoneda1 : value.GastosDeSepelioMoneda2;
      mo.OtrasPrestaciones = menoda ? value.OtrasPrestacionesMoneda1 : value.OtrasPrestacionesMoneda2;
      mo.TipoFasar = menoda ? value.TipoFasarMoneda1 : value.TipoFasarMoneda2;
      mo.RiesgosDeTrabajo = menoda ? value.RiesgosDeTrabajoMoneda1 : value.RiesgosDeTrabajoMoneda2;
      mo.CostoTotal = menoda ? value.CostoTotalMoneda1 : value.CostoTotalMoneda2;
      mo.Fecha = menoda ? value.FechaMoneda1 : value.FechaMoneda2;

      return mo;
    });
  }

  public inicializarRegistroUnaMoneda():ClsManoDeObraMoneda  {
    const fecha = new Date();
    const ma: ClsManoDeObraMoneda = new ClsManoDeObraMoneda();
    // Copia propiedades comunes
    ma.IdCatalogo = BigInt('0');
    ma.Codigo = '';
    ma.DescripcionLarga = 'Código nuevo';
    ma.Descripcion = 'Código nuevo';
    ma.Unidad = 'UNIDAD';
    ma.Tipo = 2;
    ma.Participa = false;
    ma.EsPorcentaje = false;
    ma.SalarioBase = 0;
    ma.FactorSalarioIntegrado = 1;
    ma.Fasar = 1;
    ma.SalarioIntegrado = 0;
    ma.SalarioReal = 0;
    ma.Viaticos = 0;
    ma.AlimentacionHospedaje = 0;
    ma.GastosSepelio = 0;
    ma.OtrasPrestaciones = 0;
    ma.RiesgosDeTrabajo = 0;
    ma.CostoTotal = 0;
    ma.TipoFasar = 1;
    ma.Fecha = new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());

    return ma;
  }

  public inicializarRegistroAmbasMonedas() {
    const fecha = new Date();
    const mo: ClsManoDeObra = new ClsManoDeObra();
    mo.IdCatalogo = BigInt('0');
    mo.Codigo = '';
    mo.DescripcionLarga = 'Código nuevo';
    mo.Descripcion = 'Código nuevo';
    mo.Unidad = 'UNIDAD';
    mo.Tipo = 2;
    mo.SalarioBaseMoneda1 = 0;
    mo.SalarioBaseMoneda2 = 0;
    mo.SalarioBaseMoneda2 = 0;
    mo.FactorSalarioIntegradoMoneda1 = 1;
    mo.FactorSalarioIntegradoMoneda2 = 1;
    mo.FactorSalarioIntegradoMoneda3 = 1;
    mo.FasarMoneda1 = 1;
    mo.FasarMoneda2 = 1;
    mo.FasarMoneda3 = 1;
    mo.SalarioIntegradoMoneda1 = 0;
    mo.SalarioIntegradoMoneda2 = 0;
    mo.SalarioIntegradoMoneda3 = 0;
    mo.SalarioRealMoneda1 = 0;
    mo.SalarioRealMoneda2 = 0;
    mo.SalarioRealMoneda3 = 0;
    mo.ViaticosMoneda1 = 0;
    mo.ViaticosMoneda2 = 0;
    mo.ViaticosMoneda3 = 0;
    mo.AlimentacionYHospedajeMoneda1 = 0;
    mo.AlimentacionYHospedajeMoneda2 = 0;
    mo.AlimentacionYHospedajeMoneda3 = 0;
    mo.GastosDeSepelioMoneda1 = 0;
    mo.GastosDeSepelioMoneda2 = 0;
    mo.GastosDeSepelioMoneda3 = 0;
    mo.OtrasPrestacionesMoneda1 = 0;
    mo.OtrasPrestacionesMoneda2 = 0;
    mo.OtrasPrestacionesMoneda3 = 0;
    mo.CostoTotalMoneda1 = 0;
    mo.CostoTotalMoneda2 = 0;
    mo.CostoTotalMoneda3 = 0;
    mo.TipoFasarMoneda1 = 1;
    mo.TipoFasarMoneda2 = 1;
    mo.TipoFasarMoneda3 = 1;
    mo.RiesgosDeTrabajoMoneda1 = 0;
    mo.RiesgosDeTrabajoMoneda2 = 0;
    mo.RiesgosDeTrabajoMoneda3 = 0;
    mo.FechaMoneda1 = new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());
    mo.FechaMoneda2 = new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());
    mo.Participa = false;
    mo.EsPorcentaje = false;
    return mo;
  }

  public inicializarRegistroParaGuardar(): ClsCatalogoMOCalculo {
    const mo: ClsCatalogoMOCalculo = new ClsCatalogoMOCalculo();

    mo.SalarioBaseMoneda1 = 0;
    mo.FactorSalarioIntegradoMoneda1 = 1;
    mo.FasarMoneda1 = 1;
    mo.SalarioIntegradoMoneda1 = 0;
    mo.SalarioRealMoneda1 = 0;
    mo.ViaticosMoneda1 = 0;
    mo.AlimentacionYHospedajeMoneda1 = 0;
    mo.GastosDeSepelioMoneda1 = 0;
    mo.OtrasPrestacionesMoneda1 = 0;
    mo.RiesgosdeTrabajoMoneda1 = 0;
    mo.TipoFasarMoneda1 = 0;
    mo.SalarioBaseMoneda2 = 0;
    mo.FactorSalarioIntegradoMoneda2 = 1;
    mo.FasarMoneda2 = 1;
    mo.SalarioIntegradoMoneda2 = 0;
    mo.SalarioRealMoneda2 = 0;
    mo.ViaticosMoneda2 = 0;
    mo.AlimentacionYHospedajeMoneda2 = 0;
    mo.GastosDeSepelioMoneda2 = 0;
    mo.OtrasPrestacionesMoneda2 = 0;
    mo.RiesgosdeTrabajoMoneda2 = 0;
    mo.TipoFasarMoneda2 = 0;
    mo.SalarioBaseMoneda3 = 0;
    mo.FactorSalarioIntegradoMoneda3 = 1;
    mo.FasarMoneda3 = 1;
    mo.SalarioIntegradoMoneda3 = 0;
    mo.SalarioRealMoneda3 = 0;
    mo.ViaticosMoneda3 = 0;
    mo.AlimentacionYHospedajeMoneda3 = 0;
    mo.GastosDeSepelioMoneda3 = 0;
    mo.OtrasPrestacionesMoneda3 = 0;
    mo.RiesgosdeTrabajoMoneda3 = 0;
    mo.TipoFasarMoneda3 = 0;

    return mo;
  }

  public updateCell(catalogoMAT: ClsManoDeObraMoneda, rowId: number) {
    // Definir los campos a actualizar
    const fieldsToUpdate = [
      { value: catalogoMAT.Participa, key: 'Participa' },
      { value: catalogoMAT.EsPorcentaje, key: 'EsPorcentaje' },
      { value: catalogoMAT.Codigo, key: 'Codigo' },
      { value: catalogoMAT.Descripcion, key: 'Descripcion' },
      { value: catalogoMAT.DescripcionLarga, key: 'DescripcionLarga' },
      { value: catalogoMAT.Tipo, key: 'Tipo' },
      { value: catalogoMAT.Unidad, key: 'Unidad' },
      { value: catalogoMAT.SalarioBase, key: 'SalarioBase' },
      { value: catalogoMAT.FactorSalarioIntegrado, key: 'FactorSalarioIntegrado' },
      { value: catalogoMAT.Fasar, key: 'Fasar' },
      { value: catalogoMAT.SalarioIntegrado, key: 'SalarioIntegrado' },
      { value: catalogoMAT.SalarioReal, key: 'SalarioReal' },
      { value: catalogoMAT.Viaticos, key: 'Viaticos' },
      { value: catalogoMAT.AlimentacionHospedaje, key: 'AlimentacionHospedaje' },
      { value: catalogoMAT.GastosSepelio, key: 'GastosSepelio' },
      { value: catalogoMAT.OtrasPrestaciones, key: 'OtrasPrestaciones' },
      { value: catalogoMAT.CostoTotal, key: 'CostoTotal' },
      { value: catalogoMAT.RiesgosDeTrabajo, key: 'RiesgosDeTrabajo' },
      { value: catalogoMAT.TipoFasar, key: 'TipoFasar' },
      { value: catalogoMAT.Fecha, key: 'Fecha' }
    ];

    // Actualizar las celdas en la cuadrícula
    fieldsToUpdate.forEach(field => {
      this.gridMO.updateCell(field.value, rowId, field.key);
    });
  }

  public updateCellCalcularCostoTotal(salarioBase: number, fasar: number, factorSalarioIntegrado: number ,viaticos: number, alimentacionHospedaje: number, gastosSepelio: number,
                                      otrasPrestaciones: number, rowId: any) {
    const fecha = new Date();
    if (fasar < 1) { fasar = 1 }
    if (factorSalarioIntegrado < 1) { factorSalarioIntegrado = 1 }
    const salarioReal: number = ClsUtil.redondearMoneda(salarioBase * fasar, this.infPpto.decimalredondearimporte);
    const salarioIntegrado: number = ClsUtil.redondearMoneda(salarioBase * factorSalarioIntegrado, this.infPpto.decimalredondearimporte);
    const sumaGastos: number = ClsUtil.redondearMoneda(viaticos + alimentacionHospedaje + gastosSepelio + otrasPrestaciones, this.infPpto.decimalredondearimporte);
    this.gridMO.updateCell(salarioReal, rowId, 'SalarioReal');
    this.gridMO.updateCell(salarioIntegrado, rowId, 'SalarioIntegrado');
    this.gridMO.updateCell(ClsUtil.redondearMoneda(salarioReal + sumaGastos, this.infPpto.decimalredondearimporte), rowId, 'CostoTotal');
    this.gridMO.updateCell(new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds()), rowId, 'Fecha');
  }

  public compararSiCambioAnyCamposCataGrl(newValor: ClsManoDeObraMoneda, oldValor: ClsManoDeObraMoneda): boolean {
    // Retornar true si oldValor es nulo
    if (ClsUtil.esNulo(oldValor)) {
      return true;
    }
    // Definir los campos a comparar
    const campos = ['Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad', 'CostoTotal', 'Fecha'];

    // Comparar cada campo
    for (const campo of campos) {
      if (campo === 'Fecha') {
        if (ClsUtil.cadenaX(newValor[campo]) !== ClsUtil.cadenaX(oldValor[campo])) {
          return true;
        }
      } else {
        if (newValor[campo] !== oldValor[campo]) {
          return true;
        }
      }
    }

    // Si no hubo cambios, retornar false
    return false;
  }

  public compararSiCambioAnyCamposCostosMO(newValor: ClsManoDeObraMoneda, oldValor: ClsManoDeObraMoneda): boolean {
    // Retornar true si oldValor es nulo
    if (ClsUtil.esNulo(oldValor)) {
      return true;
    }

    // Definir los campos a comparar
    const campos = ['SalarioBase', 'FactorSalarioIntegrado', 'Fasar', 'SalarioIntegrado', 'SalarioReal',
      'Viaticos', 'AlimentacionHospedaje', 'GastosSepelio', 'OtrasPrestaciones', 'TipoFasar'];

    // Comparar cada campo
    for (const campo of campos) {
      if (newValor[campo] !== oldValor[campo]) {
        return true; // Retornar true si hay un cambio
      }
    }

    // Si no hubo cambios, retornar false
    return false;
  }

  public crearMenuContextual(esMaestro: boolean) {
    const subLayout: INeodataMenu[] = [
      { id: EnumMasOpciones.Ajustar, descripcion: 'MENUCONTEXTUAL.ALTO_FILA', icono: 'wrap_text', disabled: false, divisor: true },
      { id: EnumMCGenerales.GuardarLayout, descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT', icono: 'save', disabled: false, divisor: false },
      { id: EnumMCGenerales.ReestablecerLayout, descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT', icono: 'restore', disabled: false, divisor: false }
    ];
    return this.menus = [
      { id: EnumMCExpInsumos.Participa, descripcion: 'MENUCONTEXTUAL.PARTICIPA', icono: 'dynamic_feed', disabled: false, divisor: false },
      { id: EnumMCGenerales.FASAR, descripcion: 'MENUCONTEXTUAL.FASAR', icono: 'price_check', disabled: false, divisor: false },
      { id: EnumMCGenerales.AsignarTipoJornada, descripcion: 'MENUCONTEXTUAL.ASIGNAR_TIPO_JORNADA', icono: 'work_history', disabled: esMaestro, divisor: true },
      { id: EnumMCGenerales.Copiar, descripcion: 'MENUCONTEXTUAL.COPIAR', icono: 'content_copy', disabled: esMaestro, divisor: false  },
      // { id: EnumMCGenerales.Pegar, descripcion: 'MENUCONTEXTUAL.PEGAR', icono: 'content_paste', disabled: esMaestro, divisor: false  },
      { id: 'layout', descripcion: 'MENUCONTEXTUAL.LAYOUT', icono: 'grid_on', disabled: false, divisor: false, subMenu: subLayout }
    ];
  }

  public actualizarListaCostosMO(costosMO: ClsCatalogoCalculo[]) {
    const allCostoMO: ClsCatalogoMOCalculo[] =  ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CostosMOCalculo || [];
    costosMO.forEach(value => {
      value.CatalogoMO[0].IdCatalogo = value.IdCatalogo;
      const indexMO: number = allCostoMO.findIndex(value2 =>  value2.IdCatalogo === value.IdCatalogo);
      (indexMO === -1) ? allCostoMO.push(value.CatalogoMO[0]) : allCostoMO[indexMO] = value.CatalogoMO[0];
    })
  }

  public buscarIdCatalogoCostoMO(idCatalogoMO: bigint):ClsCatalogoMOCalculo {
    const allCostoOP: ClsCatalogoMOCalculo[] =  ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CostosMOCalculo || [];
    return allCostoOP.find(value =>  value.IdCatalogo === idCatalogoMO);
  }
  /**
   * Metodo que regresa el index o posicion del registro de la lista del ppto activo
   * @param codigo valor a buscar
   * @param dataMO data de MO
   */
  public existeCodigoCatalogoMOIndex(codigo: string, dataMO: ClsManoDeObraMoneda[]): number {
    return dataMO.findIndex(insumo => insumo.Codigo.toUpperCase() === codigo.toUpperCase());
  }

  public enterBus(buscar: string, buscarInicio: boolean) {
    try {
      // Inicializar arrays
      this.gridMO.data.push(...this.gridDataCompleta);
      this.gridDataCompleta = [];
      this.gridDataFiltrada = [];

      // Limpiar y procesar el valor de búsqueda
      buscar = ClsUtil.quitarAcentos(buscar.trim());
      if (buscar === '') {
        this.gridMO.data =  this.dataMO;
        return;
      }

      // Filtrar los datos
      this.gridMO.data = this.gridMO.data.filter((item: ClsManoDeObraMoneda) => {
        if (ClsUtil.filtroGridMatchItem(item, ['Codigo', 'DescripcionLarga', 'Unidad'], buscarInicio, buscar)) {
          this.gridDataFiltrada.push(item);
          return true;
        } else {
          this.gridDataCompleta.push(item);
          return false;
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
    return this.gridDataFiltrada;
  }
}
